/**
 * Convert bytes to human readable size
 * @param {number} bytes
 * @param {number} decimals
 * @returns {string}
 */
function getFormattedFileSize(bytes, decimals = 2) {
  if (!bytes || bytes === 0) return '0 B';

  const k = 1024;
  const dm = Math.max(decimals, 0);
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}

export default getFormattedFileSize;
